import axios from "axios";

/**
 * Anomaly Detection API service.
 *
 * Talks only to the Node backend (base URL already includes /api/admin). The
 * backend proxies the Python crop-monitoring service, so the frontend stays
 * isolated from it. Follows the project _services convention: methods resolve
 * with the response data / reject with error.response.
 */
const BASE = "anomaly-detection";

export default {
  // Available anomaly dates for a geofence (proxied Python /getdates/)
  async getAvailableDates(payload) {
    try {
      const { data } = await axios.post(`${BASE}/available-dates`, payload);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async getGuide() {
    try {
      const { data } = await axios.get(`${BASE}/guide`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  // Generate a report (create + enqueue background generation)
  async generateReport(payload) {
    try {
      const { data } = await axios.post(`${BASE}`, payload);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async listReports(params) {
    try {
      const { data } = await axios.get(`${BASE}`, { params });
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  // Single report detail (poll this until status !== GENERATING)
  async getReport(reportUid) {
    try {
      const { data } = await axios.get(`${BASE}/${reportUid}`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async getRelatedDates(reportUid) {
    try {
      const { data } = await axios.get(`${BASE}/${reportUid}/related-dates`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  // Comparison — ensure reports exist for the given dates (generate missing)
  async compareReports(payload) {
    try {
      const { data } = await axios.post(`${BASE}/compare`, payload);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async deleteReport(reportUid) {
    try {
      const { data } = await axios.delete(`${BASE}/${reportUid}`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async submitFeedback(reportUid, payload) {
    try {
      const { data } = await axios.post(`${BASE}/${reportUid}/feedback`, payload);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async getFeedback(reportUid) {
    try {
      const { data } = await axios.get(`${BASE}/${reportUid}/feedback`);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },

  async downloadPdf(reportUid) {
    try {
      const res = await axios.post(
        `${BASE}/${reportUid}/download-pdf`,
        {},
        { responseType: "blob" }
      );
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error.response);
    }
  },
};
